import { render, staticRenderFns } from "./DeviceMessageInfo.vue?vue&type=template&id=4fff355f&scoped=true&"
import script from "./DeviceMessageInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceMessageInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceMessageInfo.vue?vue&type=style&index=0&id=4fff355f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff355f",
  null
  
)

export default component.exports